import React from 'react';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import './modal-title.css';
function ModalTitle(props) {
    const { id, value } = props;
    if (!value) {
        return null;
    }
    return React.createElement("div", { className: "c-modal__title u-hide@empty", id: id }, MessageService.translate(value));
}
export { ModalTitle, };
//# sourceMappingURL=modal-title.js.map